import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import styles from './Button.module.css';

const Button = ({text, link, marginBottom}) => {
    
    return (
        <Link to={link} className={styles.Button}>{text}</Link>
        
    );
};

export default Button;

// type checking 
Button.propTypes = {
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    marginBottom: PropTypes.string
}
